export default "__VITE_ASSET__DZa_Ylys__"